import * as components from './components';

/** @desc отдельные компоненты из которых можно собирать свои формы,
 * например для чекаута или сертификата */
export const RegistrationFormUI = components;

export { RegistrationForm } from './RegistrationForm';
